import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { City } from '../models/cities.model';
import { environment } from 'src/environments/environment';
import { mockCities } from '../models/cities.model';
import { of, throwError } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class CitiesServerService {
    private url = `${environment.apiUrl}/cities`;

    constructor(private http: HttpClient) {}

    getCitiesFromServer(): Observable<any> {
        return this.http.get(this.url);
    }   

    setSelectCityToServer(city: City): Observable<City> {
        return of(city);
      }
}